import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Cookie from "js-cookie";
import HomePageLayout from "examples/LayoutContainers/HomePageLayout";
import logo from "../../assets/images/logos/kotacrop.png";
import businessForms from "../../assets/landingimages/images/Business Forms.png";
import payout from "../../assets/landingimages/images/payreceipt.png";
import account from "../../assets/landingimages/images/accounts.png";
import datadock from "../../assets/landingimages/images/datamack.png";
import employeeManagement from "../../assets/landingimages/images/employeeManagement.png";
import image from "../../assets/landingimages/images/image.png";
import { useMaterialUIController, setUser, setMiniSidebar } from "context";
import URLs from "constants/urls";
import { AUTH_STORAGE_KEY } from "constants/auth";
import { transformModuleMenuData } from "utils/transformModuleMenuData";
import Swal from "sweetalert2";
import { Container } from "@mui/material";

if (!document.head.querySelector("#landing-anim-styles")) {
  const s = document.createElement("style");
  s.id = "landing-anim-styles";
  s.innerHTML = `
    @keyframes orbitSpin {
      from { transform: translate(-50%,-50%) rotate(0deg); }
      to   { transform: translate(-50%,-50%) rotate(360deg); }
    }
    @keyframes ripple {
      0%   { transform: translate(-50%,-50%) scale(0.9); opacity:0.55; }
      100% { transform: translate(-50%,-50%) scale(1.75); opacity:0; }
    }
    @keyframes centerGlow {
      0%,100% { box-shadow: 0 0 28px 6px rgba(255,102,0,0.35); }
      50%      { box-shadow: 0 0 55px 18px rgba(255,80,0,0.22); }
    }
    @keyframes moduleGlowPulse {
      0%,100% { filter: brightness(1); }
      50%      { filter: brightness(1.15); }
    }
    @keyframes revolveOne {
      0%   { transform: rotate(0deg)   translateX(clamp(100px, 15vw, 150px)) rotate(0deg); }
      50%  { transform: rotate(180deg) translateX(clamp(100px, 15vw, 150px)) rotate(-180deg); }
      100% { transform: rotate(360deg) translateX(clamp(100px, 15vw, 150px)) rotate(-360deg); }
    }
    @keyframes revolveTwo {
      0%   { transform: rotate(0deg)    translateX(clamp(150px, 20vw, 200px)) rotate(0deg); }
      50%  { transform: rotate(-180deg) translateX(clamp(150px, 20vw, 200px)) rotate(180deg); }
      100% { transform: rotate(-360deg) translateX(clamp(150px, 20vw, 200px)) rotate(-360deg); }
    }
    @keyframes revolveThree {
      0%   { transform: rotate(90deg)  translateX(clamp(200px, 28vw, 290px)) rotate(-90deg); }
      50%  { transform: rotate(270deg) translateX(clamp(200px, 28vw, 290px)) rotate(-270deg); }
      100% { transform: rotate(450deg) translateX(clamp(200px, 28vw, 290px)) rotate(-450deg); }
    }
    @keyframes revolveFour {
      0%   { transform: rotate(45deg)   translateX(clamp(260px, 35vw, 370px)) rotate(-45deg); }
      50%  { transform: rotate(-135deg) translateX(clamp(260px, 35vw, 370px)) rotate(135deg); }
      100% { transform: rotate(-315deg) translateX(clamp(260px, 35vw, 370px)) rotate(315deg); }
    }
  `;
  document.head.appendChild(s);
}

const ORANGE_GRADIENT = "linear-gradient(135deg,#FF6600,#E64A19)";
const ORANGE_GLOW = "rgba(255,102,0,0.55)";

const MODULE_HOVER = [
  { hoverGradient: "linear-gradient(135deg,#4A90D9,#1565C0)", hoverGlow: "rgba(74,144,217,0.75)" },
  { hoverGradient: "linear-gradient(135deg,#9C27B0,#6A1B9A)", hoverGlow: "rgba(156,39,176,0.75)" },
  { hoverGradient: "linear-gradient(135deg,#FF6600,#E64A19)", hoverGlow: "rgba(255,102,0,0.75)" },
  { hoverGradient: "linear-gradient(135deg,#00C853,#1B5E20)", hoverGlow: "rgba(0,200,83,0.75)" },
  { hoverGradient: "linear-gradient(135deg,#F44336,#B71C1C)", hoverGlow: "rgba(244,67,54,0.75)" },
];

const BG_GRADIENT = "linear-gradient(to bottom right, #f5f7fa, rgb(192, 13, 13))";

const LandingDashboard = () => {
  const navigate = useNavigate();
  const [controller, dispatch] = useMaterialUIController();
  const { user } = controller;
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const setAlert = (errMsg) =>
    Swal.fire({ icon: "error", title: "Access Denied!", text: errMsg, confirmButtonText: "OK" });

  const baseCardsData = [
    {
      title: "Business Forms",
      image: businessForms,
      moduleId: 1,
      gradient: ORANGE_GRADIENT,
      glow: ORANGE_GLOW,
    },
    {
      title: "Admin",
      image: employeeManagement,
      moduleId: 2,
      gradient: ORANGE_GRADIENT,
      glow: ORANGE_GLOW,
    },
    { title: "HRMS", image: payout, moduleId: 3, gradient: ORANGE_GRADIENT, glow: ORANGE_GLOW },
    { title: "Finance", image: account, moduleId: 4, gradient: ORANGE_GRADIENT, glow: ORANGE_GLOW },
    {
      title: "Report Center",
      image: datadock,
      moduleId: 5,
      gradient: ORANGE_GRADIENT,
      glow: ORANGE_GLOW,
    },
  ];

  useEffect(() => {
    Cookie.get("employee_id");
  }, []);
  useEffect(() => {
    navigate("/landing-page", { replace: true });
  }, []);
  useEffect(() => {
    window.history.pushState(null, null, window.location.href);
    const fn = () => {
      if (localStorage.getItem("authToken")) navigate("/landing-page", { replace: true });
    };
    window.addEventListener("popstate", fn);
    return () => window.removeEventListener("popstate", fn);
  }, [navigate]);

  const handleModuleClick = async (moduleId) => {
    if (!user) {
      setAlert("Your session has expired. Please log in again.");
      navigate("/landing-page");
      Cookie.remove("access_token");
      Cookie.remove("jwt_token");
      Cookie.remove("hrms_token");
      return;
    }
    if (!user.employeeId) {
      setAlert("Employee ID not found. Please log in again.");
      navigate("/landing-page");
      Cookie.remove("access_token");
      Cookie.remove("jwt_token");
      Cookie.remove("hrms_token");
      return;
    }
    try {
      const response = await fetch(
        `${URLs.userManuByModuleId}?employeeId=${user.employeeId}&moduleId=${moduleId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookie.get("jwt_token")}`,
          },
        }
      );
      if (response.status === 204) {
        setAlert("You are not authorized to access this module");
        return;
      }
      if (!response.ok) throw new Error("Failed to fetch menu access details");
      const menuDetails = await response.json();
      if (!menuDetails || menuDetails.length === 0) {
        setAlert("You are not authorized to access this module");
        return;
      }
      const transformedMenu = transformModuleMenuData(menuDetails);
      setUser(dispatch, { ...user, menu: transformedMenu });
      setMiniSidebar(dispatch, true);
      // Persist the raw (JSON-safe) module menu + expanded sidebar state so
      // a browser refresh on a page within this module can rebuild the same
      // view instead of resetting to the collapsed default.
      localStorage.setItem(
        AUTH_STORAGE_KEY,
        JSON.stringify({ ...user, menu: menuDetails, menuSource: "module", miniSidebar: true })
      );
      if (menuDetails[0]?.routingPath) navigate(menuDetails[0].routingPath);
      else setAlert("Invalid module data. No routing path available.");
    } catch (error) {
      setAlert(error.message || "Something went wrong");
    }
  };

  const circleSize = 580;
  const circleRadius = 215;

  return (
    <HomePageLayout>
      <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            flex: 1,
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: BG_GRADIENT,
            overflow: "hidden",
            py: 2,
          }}
        >
          <Box
            sx={{
              position: "relative",
              zIndex: 10,
              background: "rgba(0,0,0,0.45)",
              backdropFilter: "blur(6px)",
              borderRadius: "30px",
              px: 4,
              py: 1.2,
              mb: 3,
              border: "1px solid rgba(255,200,100,0.35)",
              boxShadow: "0 4px 24px rgba(0,0,0,0.3), 0 0 18px rgba(255,150,50,0.2)",
            }}
          >
            <Typography
              sx={{
                color: "#FFD700",
                fontWeight: 700,
                fontSize: "1.05rem",
                letterSpacing: 1.8,
                textTransform: "uppercase",
                textShadow: "0 0 14px rgba(255,200,50,0.8)",
              }}
            >
              ✦ Explore Our Modules ✦
            </Typography>
          </Box>

          <Box
            sx={{
              position: "relative",
              zIndex: 10,
              width: `${circleSize}px`,
              height: `${circleSize}px`,
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                width: `${circleRadius * 2 + 50}px`,
                height: `${circleRadius * 2 + 50}px`,
                borderRadius: "50%",
                border: "3px dashed rgba(255,200,80,0.65)",
                transform: "translate(-50%,-50%)",
                animation: "orbitSpin 22s linear infinite",
              }}
            />

            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                width: `${circleRadius * 2 + 130}px`,
                height: `${circleRadius * 2 + 130}px`,
                borderRadius: "50%",
                border: "2px dashed rgba(255,140,0,0.45)",
                transform: "translate(-50%,-50%)",
                pointerEvents: "none",
                animation: "orbitSpin 35s linear infinite reverse",
              }}
            />

            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%,-50%)",
                width: "148px",
                height: "148px",
                borderRadius: "50%",
                bgcolor: "#fff",
                animation: "centerGlow 3s ease-in-out infinite",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 5,
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="Kota Holdings"
                sx={{ width: "115px", height: "115px", borderRadius: "50%", objectFit: "contain" }}
              />
            </Box>

            {baseCardsData.map((item, index) => {
              const angleDeg = (360 / baseCardsData.length) * index - 90;
              const angleRad = (angleDeg * Math.PI) / 180;
              const x = circleSize / 2 + circleRadius * Math.cos(angleRad);
              const y = circleSize / 2 + circleRadius * Math.sin(angleRad);
              const isHov = hoveredIndex === index;
              const hov = MODULE_HOVER[index];

              return (
                <Box
                  key={item.title}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  onClick={() => handleModuleClick(item.moduleId)}
                  sx={{
                    position: "absolute",
                    left: `${x}px`,
                    top: `${y}px`,
                    transform: "translate(-50%,-50%)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                    zIndex: isHov ? 20 : 4,
                  }}
                >
                  {isHov && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -60%)",
                        width: "160px",
                        height: "160px",
                        borderRadius: "50%",
                        background: `radial-gradient(circle, ${hov.hoverGlow} 0%, transparent 70%)`,
                        pointerEvents: "none",
                        zIndex: 0,
                        filter: "blur(10px)",
                        animation: "moduleGlowPulse 1.5s ease-in-out infinite",
                      }}
                    />
                  )}

                  <Box
                    sx={{
                      width: isHov ? "122px" : "105px",
                      height: isHov ? "122px" : "105px",
                      borderRadius: "50%",
                      bgcolor: "#fff",
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden",
                      transition: "all 0.35s cubic-bezier(0.34,1.56,0.64,1)",
                      boxShadow: isHov
                        ? `0 0 0 5px ${hov.hoverGlow}, 0 14px 42px ${hov.hoverGlow}, 0 0 30px ${hov.hoverGlow}`
                        : "0 6px 24px rgba(0,0,0,0.35), 0 2px 8px rgba(255,100,0,0.2)",
                    }}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        inset: isHov ? "-5px" : "-4px",
                        borderRadius: "50%",
                        background: isHov ? hov.hoverGradient : item.gradient,
                        zIndex: 0,
                        transition: "all 0.35s ease",
                      }}
                    />

                    <Box
                      sx={{
                        position: "absolute",
                        inset: isHov ? "5px" : "4px",
                        borderRadius: "50%",
                        bgcolor: "#fff",
                        zIndex: 1,
                        transition: "all 0.35s ease",
                      }}
                    />

                    <Box
                      component="img"
                      src={item.image}
                      alt={item.title}
                      sx={{
                        width: isHov ? "88px" : "66px",
                        height: isHov ? "88px" : "66px",
                        objectFit: "contain",
                        position: "relative",
                        zIndex: 2,
                        transition: "all 0.35s cubic-bezier(0.34,1.56,0.64,1)",
                        filter: isHov
                          ? `drop-shadow(0 0 10px ${hov.hoverGlow}) drop-shadow(0 4px 8px rgba(0,0,0,0.2))`
                          : "drop-shadow(0 2px 4px rgba(0,0,0,0.12))",
                      }}
                    />
                  </Box>

                  <Typography
                    sx={{
                      mt: "10px",
                      fontSize: isHov ? "14.5px" : "13px",
                      fontWeight: 800,
                      background: isHov ? hov.hoverGradient : "none",
                      WebkitBackgroundClip: isHov ? "text" : "unset",
                      WebkitTextFillColor: isHov ? "transparent" : "#FFFFFF",
                      color: isHov ? "transparent" : "#FFFFFF",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      letterSpacing: "0.4px",
                      transition: "all 0.3s ease",
                      textShadow: isHov ? "none" : "0 1px 6px rgba(0,0,0,0.6)",
                    }}
                  >
                    {item.title}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>

        <Box
          sx={{
            bgcolor: "#1a0000",
            py: 1.5,
            textAlign: "center",
            borderTop: "2px solid #FF6600",
          }}
        >
          <Container maxWidth="lg">
            <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
              <Typography sx={{ color: "#FFD0A0", fontSize: "0.7rem" }}>
                Designed by{" "}
                <a
                  href="https://www.sconexsoft.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#FF6600", textDecoration: "none" }}
                >
                  Sconexsoft
                </a>
              </Typography>
              <Box
                component="img"
                src={image}
                alt="Brand Logo"
                sx={{
                  height: { xs: "24px", md: "32px" },
                  maxWidth: "140px",
                  borderRadius: "7px",
                  pl: 1,
                  pr: 1,
                  objectFit: "contain",
                  backgroundColor: "#ffffff",
                  border: "1px solid rgba(255,150,50,0.4)",
                }}
              />
            </Box>
          </Container>
        </Box>
      </Box>
    </HomePageLayout>
  );
};

export default LandingDashboard;
